import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { ASSETS } from "@/lib/brand";

const links = [
  { href: "#mission", label: "Mission" },
  { href: "#paula", label: "Paula" },
  { href: "#buch", label: "Buch" },
  { href: "#app", label: "App" },
  { href: "#held", label: "HELD-Regel" },
  { href: "#schulen", label: "Schulen" },
  { href: "#foerderer", label: "Förderer" },
  { href: "#shop", label: "Shop" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#FAF9F6]/85 backdrop-blur-md border-b border-slate-200"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 sm:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <div className="w-11 h-11 rounded-full bg-white border border-slate-200 grid place-items-center overflow-hidden shadow-sm">
            <img
              src={ASSETS.paulaCharacter}
              alt="Paula"
              className="w-10 h-10 object-contain"
            />
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-paula-ink text-base">
              Pinguin Paula
            </div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-paula-muted">
              Bleib cool
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-paula-ink/80 hover:text-paula-red transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#shop"
            data-testid="nav-cta-buy"
            className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-paula-ink text-white text-sm font-semibold hover:bg-paula-red transition-colors"
          >
            Buch kaufen
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 rounded-full border border-slate-200 bg-white"
            aria-label="Menü"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200">
          <div className="px-6 py-5 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-paula-ink"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#shop"
              data-testid="mobile-cta-buy"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex justify-center items-center px-5 py-3 rounded-full bg-paula-ink text-white font-semibold"
            >
              Buch kaufen
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
